import type { Component } from '../router';
import { rerender } from '../router';
import { getLocale, setLocale, t } from '../i18n/locale';
import { LOCALES, LOCALE_LABELS, type Locale } from '../i18n/catalog';

// LanguageSwitcher — a native <select> for EN/ES/PT. On change it remembers the
// choice (+ reflects ?lang in the URL) and re-renders the current route so every
// string re-reads through i18n `t()`. Native control = keyboard + a11y for free.
export class LanguageSwitcher implements Component {
  private root: HTMLElement | null = null;

  mount(host: HTMLElement): void {
    // A compact native <select> with a chevron (see i18n.css). The "Language"
    // caption is carried by aria-label only — a visible caption beside it just
    // crowded the nav; the globe-less dropdown reads as the language control on
    // its own.
    const wrap = document.createElement('label');
    wrap.className = 'lang-switch';

    const select = document.createElement('select');
    select.className = 'lang-switch__select';
    select.setAttribute('aria-label', t('lang.label'));
    const active = getLocale();
    for (const loc of LOCALES) {
      const opt = document.createElement('option');
      opt.value = loc;
      opt.textContent = LOCALE_LABELS[loc];
      if (loc === active) opt.selected = true;
      select.appendChild(opt);
    }
    select.addEventListener('change', () => {
      setLocale(select.value as Locale);
      rerender();
    });

    wrap.append(select);
    host.appendChild(wrap);
    this.root = wrap;
  }

  unmount(): void {
    this.root?.remove();
    this.root = null;
  }
}
